import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-cookie-consent', 'mainTitle', 'Mūsu sīkdatnes – jūsu izvēle');
Labels.set('ui-cookie-consent', 'settingsTitle', 'Sīkdatņu uzstādījumi');
Labels.set(
    'ui-cookie-consent',
    'mainInfo',
    'Swedbank Grupas {entitiesLink} {country} izmanto {cookiesLink} vai līdzīgas tehnoloģijas, kas nepieciešamas šīs tīmekļa vietnes darbībai. Papildu jūs varat izvēlēties sīkdatnes, lai uzlabotu un personalizētu savu pieredzi:'
);
Labels.set(
    'ui-cookie-consent',
    'secondaryInfo',
    'Jūs varat pārvaldīt savu izvēli attiecībā uz neobligātajām sīkdatnēm, nospiežot "Pārvaldīt sīkdatnes". Savu piekrišanu jebkurā laikā varat atsaukt mūsu {usageLink}. Plašākai informācijai skatiet mūsu {policyLink}.'
);
Labels.set(
    'ui-cookie-consent',
    'settingsInfo',
    'Savu piekrišanu jebkurā laikā varat atsaukt mūsu {usageLink}. Plašākai informācijai skatiet mūsu {policyLink}.'
);
Labels.set(
    'ui-cookie-consent',
    'thirdPartyDisclaimer',
    'Šajā tīmekļa vietnē tiek izmantotas trešo pušu sīkdatnes.'
);
Labels.set('ui-cookie-consent', 'accept', 'Apstiprināt visas sīkdatnes');
Labels.set(
    'ui-cookie-consent',
    'decline',
    'Apstiprināt tikai nepieciešamās sīkdatnes'
);
Labels.set('ui-cookie-consent', 'myCookies', 'Pārvaldīt sīkdatnes');
Labels.set('ui-cookie-consent', 'saveChoice', 'Saglabāt sīkdatņu iestatījumus');
Labels.set('ui-cookie-consent', {
    HELP_NECESSARY:
        'Šīs sīkdatnes ir būtiskas, lai vietne darbotos pareizi un droši, un tos nevar noraidīt. Tās nodrošina svarīgas funkcijas, piemēram, pievienošanās un valodas iestatījumus.',
    HELP_ANALYTICAL:
        'Palīdz mums saprast, kā lietotāji izmanto mūsu vietni, kuras funkcijas ir populāras, kuras vietas var būt problemātiskas. Mēs izmantojam šos datus, lai uzlabotu mūsu vietni. Ja atteiksieties, mēs nevarēsim apkopot statistiku.',
    HELP_TARGETING:
        'Palīdz sniegt jums personalizētu informāciju par mūsu produktiem un pakalpojumiem. Ja atteiksieties, mēs nevarēsim piedāvāt jums personalizētu saturu.',
    HELP_FUNCTIONAL:
        'Šīs sīkdatnes uzlabo jūsu lietošanas pieredzi. Bez tām jums var nākties atkārtoti ievadīt informāciju, filtrēt saturu, vairāk darboties ar peli, un nestrādās citas noderīgas funkcijas.',
});
Labels.set('ui-cookie-consent', {
    CATEGORY_NECESSARY: 'Nepieciešamās',
    CATEGORY_TARGETING: 'Mērķauditorijas atlases',
    CATEGORY_ANALYTICAL: 'Analītiskās',
    CATEGORY_FUNCTIONAL: 'Funkcionālās',
});
Labels.set('ui-cookie-consent', {
    COOKIE_TARGETING: 'Mērķauditorijas atlases',
    COOKIE_ANALYTICAL: 'Analītiskās',
    COOKIE_FUNCTIONAL: 'Funkcionālās',
});
Labels.set('ui-cookie-consent', 'EE', 'Igaunija');
Labels.set('ui-cookie-consent', 'LV', 'Latvijā');
Labels.set('ui-cookie-consent', 'LT', 'Lietuva');
Labels.set('ui-cookie-consent', 'entities', 'uzņēmumi');
Labels.set('ui-cookie-consent', 'cookies', 'sīkdatnes');
Labels.set('ui-cookie-consent', 'language', 'Valodu');
Labels.set('ui-cookie-consent', 'usage', 'Sīkdatņu izmantošanas lapā');
Labels.set('ui-cookie-consent', 'policyLinkLabel', 'Sīkdatņu politiku');
